module.exports = __webpack_public_path__ + "media/images/top-2-9426811f99c4d36242d066bfcadb0e36.png";